import * as S from "../../Style/Page/Fork.style.js";
import { Link } from "react-router-dom";
import { ReactComponent as Home } from "../../assets/icon/home.svg";
import Arrow from "../../assets/icon/lnb_arrow.png";
import PageTitle from "../../Component/PageTitleFork.js";
import ForkLift from "../../assets/fork/03. 지게차사업 소개 지게차3.png";
import Mapimg from "../../assets/fork/04. 지게차사업 글로벌 지도.png";
import HatPageTopLine from "../../Component/ForkPageTopLine.js";
const Introduce = () => {
  return (
    <S.Page className={localStorage.getItem("language")}>
      <HatPageTopLine name={"지게차사업"} />
      <section className="section" id="hat-introduce-section">
        <S.PageNavidation>
          <Link to="/" className="logo">
            <Home />
          </Link>
          <S.Nav height={"364px"}>
            <S.NavItem>
              <Link to="/ForkLiftBusiness/Introduce">
                <div className="kor">지게차사업</div>
                <div className="eng">ForkLift Business</div>
              </Link>
            </S.NavItem>

            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/Introduce">
                  <div className="kor">모자사업</div>
                  <div className="eng">Hat Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/Introduce">
                  <div className="kor">지게차사업</div>
                  <div className="eng">ForkLift Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/CarBusiness/introduce">
                  <div className="kor">자동차사업</div>
                  <div className="eng">Car Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/OverseasBus">
                  <div className="kor">버스사업</div>
                  <div className="eng">Bus Business</div>
                </Link>
              </S.NavItem>

              <S.NavItem className="list-inner-item">
                <Link to="/GeneralBusiness/introduce">
                  <div className="kor">일반사업</div>
                  <div className="eng">General Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/SocialService">
                  <div className="kor">사회사업</div>
                  <div className="eng">Social Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/WBH/WBH">WBH</Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>

          <S.Nav height={"156px"}>
            <S.NavItem>
              <Link to="/ForkLiftBusiness/Introduce">
                <div className="kor">클라크</div>
                <div className="eng">ForkLift Business</div>
              </Link>
            </S.NavItem>
            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/Introduce">
                  <div className="kor">클라크</div>
                  <div className="eng">ForkLift Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOfficeUsa">
                  <div className="kor">지역별법인</div>
                  <div className="eng">Corporation by region</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/History">
                  <div className="kor">주요사업이력</div>
                  <div className="eng">Major business history</div>
                </Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>
        </S.PageNavidation>
        <div className="wrap">
          <div className="inner">
            <PageTitle
              titleko={"사업개요"}
              titleeng={"Company Profile"}
              link={"http://www.clarkmhc.co.kr/"}
            />
            <div className="page-text">
              <div className="kor">
                클라크는 미국 브랜드의 지게차 제조 및 판매 회사입니다. <br />
                클라크의 모체는 미국의 클라크 머터리얼핸들링컴퍼니(주)로 <br />
                1917년 세계 최초로 엔진 구동식 지게차를 발명하였으며, <br />
                지난 100년 동안 오버헤드가드, 마스트, 로드백레스트 등 <br />
                다양한 편의장치와 안전장치들을 지속적으로 지게차에 <br />
                적용하였고, 이를 동종 업계의 업체들과 공유하여 현대적인 <br />
                지게차의 표준을 정립하고 지게차 개발에 커다란 공헌을 해오고{" "}
                <br />
                있습니다. 2003년 영안모자 계열이 클라크의 미국 본사와 한국
                생산법인을
                <br />
                인수하였습니다. 현재는 미국 글로벌 본사(달라스)를 중심으로 전
                세계 11개국에서 7개 제조법인,
                <br />
                5개 R&D센터, 11개 판매법인을 운영하고 있습니다.
              </div>
              <div className="eng">
                CLARK is an American-branded forklift manufacturing and sales
                company. <br />
                The parent company of CLARK Forklift Truck is CLARK Material
                Handling Company in the USA. <br />
                CLARK was the pioneer of the world's first engine-powered
                forklifts in 1917, <br />
                and applied a number of convenience devices and safety devices
                such as overhead guards, <br />
                masts, and load backrests to forklift trucks and shared them
                with the peers. <br />
                CLARK has made a significant contribution to the development of
                forklift trucks <br />
                over the past 100 years. <br />
                Young An Hat Company acquired CLARK Material Handling Company{" "}
                <br />
                in the U.S.A. and its Korean manufacturing subsidiary in 2003.{" "}
                <br />
                Now, CLARK operates 7 manufacturing companies, 5 R&D centers,
                and 11 sales companies <br />
                in 11 countries around the world, centering around the Global HQ
                in the United States. <br />
              </div>
              <img src={ForkLift} className="hat-img" alt="" />
            </div>

            <PageTitle titleko={"사업자 현황"} titleeng={"Global Network"} />
            <div className="page-text">
              <div className="kor">
                미국(달라스본사, 렉싱턴, 루이빌), 멕시코, 브라질, 코스타리카
                독일,
                <br />
                프랑스 한국(부천, 창원), 중국, 베트남 호주, 싱가폴
              </div>
              <div className="eng">
                U.S.A(Dallas HQ, Lexington, Louisville), Mexico, Brazil, Costa
                Rica, Germany
                <br />
                France, Korea(Bucheon, Changwon), China, Vietnam
                <br />
                Austrailia, Singapore <br />
              </div>
            </div>
            <img className="fullsize-map" src={Mapimg} alt="" />
          </div>
        </div>
      </section>
    </S.Page>
  );
};

export default Introduce;
